import React from 'react';
import styled from 'styled-components';

const Checkbox = ({ id, checked, onChange }) => {
  return (
    <StyledWrapper>
      <label className="checkbox-wrapper">
        <input
          type="checkbox"
          id={id}
          hidden
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={id} className="checkmark" />
      </label>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .checkmark {
   display: block;
   width: 30px;
   height: 30px;
   background-color: var(--primary-color);
   border-radius: 10px;
   position: relative;
   transition: background-color 0.2s ease;
   cursor: pointer;
   will-change: background-color;
  }

  input:checked ~ .checkmark {
   background-color: var(--secondary-color);
  }

  .checkmark::after {
   content: "";
   position: absolute;
   width: 5px;
   height: 10px;
   border-right: 3px solid #fff;
   border-bottom: 3px solid #fff;
   top: 44%;
   left: 50%;
   transform: translate(-50%, -50%) rotateZ(40deg) scale(0);
   opacity: 0;
   transition: transform 0.2s ease, opacity 0.15s ease;
   will-change: transform, opacity;
  }

  input:checked ~ .checkmark::after {
   opacity: 1;
   transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
  }
`;

export default Checkbox;
